import * as React from 'react';
import styled from 'styled-components';
import { Colors, Fonts } from '../utils/colors';

export const Header = () => {
  return (
    <Wrapper>
      <Logo href="/" aria-label="Self-Destruct">
        <PromptMark aria-hidden="true">&gt;</PromptMark>
        selfdestruct
        <Cursor aria-hidden="true" />
      </Logo>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  height: 64px;
  background-color: ${Colors.headerBg};
  border-bottom: 1px solid ${Colors.terminalBorder};
  z-index: 10;
`

const Logo = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${Colors.destructGreen};
  font-family: ${Fonts.mono};
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-decoration: none;
  text-shadow: 0 0 8px ${Colors.terminalGlow};
`

const PromptMark = styled.span`
  margin-right: 8px;
  opacity: 0.72;
`

const Cursor = styled.span`
  display: inline-block;
  width: 0.55em;
  height: 1.05em;
  margin-left: 4px;
  background: ${Colors.destructGreen};
  box-shadow: 0 0 8px ${Colors.terminalGlow};
`
